import React from 'react';
import { FileText, Plus, ArrowLeft } from 'lucide-react';

const CostSheetDashboard = ({ onNavigate, onBack }) => {
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <button
            onClick={onBack}
            className="p-2 rounded-md hover:bg-gray-200 transition-colors"
            title="Back to main"
          >
            <ArrowLeft size={20} />
          </button>
          <h1 className="text-3xl font-bold">Cost Sheet</h1>
        </div>

        {/* Options Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Create New Cost Sheet */}
          <button
            onClick={() => onNavigate('create')}
            className="bg-white border-2 border-gray-200 rounded-lg p-8 hover:border-black hover:shadow-lg transition-all text-left group"
          >
            <div className="flex items-center gap-4 mb-4">
              <div className="p-3 bg-black rounded-lg group-hover:bg-gray-800 transition-colors">
                <Plus size={24} className="text-white" />
              </div>
              <h2 className="text-xl font-semibold">Create New Cost Sheet</h2>
            </div>
            <p className="text-gray-600">
              Calculate quote price with margin, shipping, and interest calculations
            </p>
          </button>

          {/* View Past Cost Sheets */}
          <button
            onClick={() => onNavigate('list')}
            className="bg-white border-2 border-gray-200 rounded-lg p-8 hover:border-black hover:shadow-lg transition-all text-left group"
          >
            <div className="flex items-center gap-4 mb-4">
              <div className="p-3 bg-black rounded-lg group-hover:bg-gray-800 transition-colors">
                <FileText size={24} className="text-white" />
              </div>
              <h2 className="text-xl font-semibold">View Past Cost Sheets</h2>
            </div>
            <p className="text-gray-600">
              Browse and manage your previously saved cost sheets
            </p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CostSheetDashboard;

